import React from "react";

const EditBalance = ({ isEditing, onEdit, onSave, onCancel, className, isSavingStocks }) => {
  if (isEditing) {
    return (
      <div className={`header__edit-group ${className || ""}`}>
        <button
          className="header__save"
          onClick={onSave}
          disabled={isSavingStocks}            // 🔒 блокируем
        >
          {isSavingStocks && <span className="btn-spinner" />} {/* ⟳ мини-спинер */}
          {isSavingStocks ? "Сохраняем…" : "💾 Сохранить"}
        </button>
        <button
          className="header__cancel"
          onClick={onCancel}
          disabled={isSavingStocks}            // 🔒 чтобы не мешать сохранению
        >
          ✖ Отмена
        </button>
      </div>
    );
  }

  return (
    <button
      className={`header__edit ${className || ""}`}
      onClick={onEdit}
      disabled={isSavingStocks}
      title={isSavingStocks ? "Идёт сохранение остатков…" : "Редактирование остатков"}
    >
      Редактирование остатков
    </button>
  );
};

export default EditBalance;
